import client, { unwrap } from "./client"

// A whole-menu download on weak restaurant wifi needs longer than the default timeout.
const SNAPSHOT_TIMEOUT_MS = 60000

// The whole menu for one restaurant + language, downloaded fresh every time.
export async function fetchMenuSnapshot({ restaurantId, language, signal, onProgress } = {}) {
  const response = await client.get("/frontline/menu-snapshot/", {
    signal,
    headers: { "restaurant-id": restaurantId, "X-Lang": language },
    timeout: SNAPSHOT_TIMEOUT_MS,
    // Bytes over the wire, so the first-run panel can show how far along the download is.
    onDownloadProgress: onProgress
      ? (event) => onProgress({ loaded: event.loaded ?? 0, total: event.total ?? 0 })
      : undefined
  })
  return unwrap(response)
}
